// Module
var code = `<!-- clHeading — section break with optional eyebrow.
     Data shape (from author):
         { level: 2-4, text: "string (markdown)", eyebrow?: "small label" }

     Pipeline normalizations:
         levelIs2 / levelIs3 / levelIs4  — exactly one is truthy, set from \`level\`
         eyebrow                          — left as-is; absent key = absent wrapper

     The flag-conditional pattern is used because DomElementTemplate cannot emit
     dynamic tag names — only content. The outer <div> carries a modifier class
     for additional per-level styling hooks. -->
<div class="block-cl-heading block-cl-heading--h{{level}}">
  <div class="block-cl-heading__eyebrow">{{eyebrow}}</div>
  <p class="block-cl-heading__text-{{level}}">{{text}}</p>

</div>
`;
// Exports
module.exports = code;